import { ChargingCardDto } from '../dto/charging-cards-dto'
import { ChargingCardModel } from '../models/charging-card-model'
import { convertCardStatus } from '../../../shared'
import { WallboxModel } from 'src/Libs/e-mobility/wallboxes/models/wallbox-model'
import { wallboxSortFn } from 'src/Libs/e-mobility/shared/utils/sort-wallboxes'

/**
 * Function for transforming charging card dto to charging card model
 * @param chargingCards - as array of ChargingCardDto or undefined
 * @returns array of ChargingCardModel
 */
export const chargingCardsTransformer = (chargingCards: ChargingCardDto[] | undefined, wallboxes: WallboxModel[]): ChargingCardModel[] => {
  return chargingCards
    ? chargingCards.map((card: ChargingCardDto) => {
        return {
          cardName: card.name,
          user: card.userInfo ? trimUserFullName(card.userInfo.firstName, card.userInfo.lastName) : '',
          status: convertCardStatus(card.card_status),
          createdAt: card.created_at,
          changedAt: card.updated_at,
          description: card.description || '',
          userId: card.userInfo ? card.userInfo.userId : null,
          tokenId: card.e_mobility_token || '',
          ocpiTokenId: card.ocpi_token_id,
          installationId: Number(card.installation_id),
          expirationDate: card.expiration_date ? card.expiration_date : null,
          linkedWallboxes: card.wallboxes
            ? card.wallboxes
                .map(linkedWallboxId => wallboxes.find(wallbox => wallbox.wallboxId === linkedWallboxId))
                .filter(wallbox => wallbox !== undefined)
                .sort(wallboxSortFn)
            : [],
        }
      })
    : []
}

const trimUserFullName = (firstName: string, lastName: string): string => {
  const fullName = `${firstName} ${lastName}`

  return fullName.trim()
}
